import React, { useState } from 'react';
import  NavBarLeft, { PIFlowLeftNavBar } from '../../ReusableComp/NavBarLeft';
import NavigationBar from '../../ReusableComp/NavigationBar';
import Select from '../../ReusableComp/Select';
import { Col, Container, Row, Stack, Table } from 'react-bootstrap';
import moment from 'moment/moment';
// import { useNavigate } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { getMarketingHeads, getQrList, getQrListStudies} from '../../../Redux/actions/actions';
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import Loader from '../../ReusableComp/Loader';
import { Tooltip } from 'react-tooltip'


const PMSAdminQRList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch(); 
    const [studyList, setStudyList] = useState([]);
    const [zoneSelected, setZoneSelected] = useState("");
    const [studySelected, setStudySelected] = useState("");
    const piList = useSelector((state) => (state.qrList));
    const qrListStudies = useSelector((state) => (state.qrListStudies));

    const [filteredData, setFilteredData] = useState(null);
    const [searchText, setSearchText] = useState('');
    const [selectedPI, setSelectedPI] = useState(null)
    const [loading_flag, Setloading_flag] = useState(false);
    const [asc,setAsC]=useState(false);
    const [desc,setDesc]=useState(false);

    const [currentPage, setCurrentPage] = useState(1)

    useEffect(() => {
        if (currentPage === 2) {
        window.scrollTo(0, 0);
        }
    }, [currentPage]);

    useEffect(() => {
        Setloading_flag(true);
        dispatch(getQrList());
        dispatch(getQrListStudies());

          const uniqueStudyNamesSet = new Set(
            piList?.flatMap(item => item.qr_studies?.map(study => study.study_name))
          );
          
          // Create a list of JSON objects with unique study_name as "value" and "label"
          const uniqueStudyNamesList = [...uniqueStudyNamesSet].map(studyName => ({
            value: studyName,
            label: studyName
          }));

          setStudyList(uniqueStudyNamesList);

    }, [dispatch]);

    
    useEffect(() => {
        if (piList) {
          setFilteredData(piList);
          setTimeout(()=>{
            Setloading_flag(false);
          },200)
        }
      }, [piList]);

    function convertToTitleCase(str) {
        return str.replace(/\w\S*/g, function(txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    }

    function disableBackButton() {
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', function(event) {
          window.history.pushState(null, null, window.location.pathname);
        });
      }
      useEffect(() => {
        disableBackButton();
      }, [])

const handleSubjectData =(data1)=>{
      navigate('/editqualityreviewer', { state: { data: data1 } });

}

const handleSubjectDataView =(data1)=>{
    setSelectedPI(data1)
    setCurrentPage(2)
}
const getRoleCode =(data)=>{
}

const handleOptionSelectStudy =(e)=>{
    let val = e.target.value;

    if(val === "All Studies"){
        val = "";
    }
    setStudySelected(val);
    
    const filteredData = piList?.filter(item => {
        const hasMatchingStudyName = item.qr_studies?.some(
            study => study.study_name?.toLowerCase().includes(val.toLowerCase())
        );
        
        return (
            hasMatchingStudyName && item.name && item.name.toLowerCase().includes(searchText.toLowerCase())
          );
        });
        setFilteredData(filteredData)
    }
    const handleClearFilters = () => {
        setZoneSelected("");
        setStudySelected("");
        setSearchText("");
        setFilteredData(piList);
        window.location.reload();
    }

    const handleSearchData = (event) => {
        const searchText = event.target.value.toLowerCase();
        setSearchText(searchText);
        const filteredData = piList?.filter((item) => {
            // Convert relevant properties to lowercase for case-insensitive search
            const hasMatchingStudyName = item.qr_studies?.some(
                study => study.study_name?.toLowerCase().includes(studySelected.toLowerCase())
            );
            return (
                item.name && item.name.toLowerCase().includes(searchText.toLowerCase()) && hasMatchingStudyName
                
              );
        });
        // Update the table or do whatever you want with the filteredData
        setFilteredData(filteredData)

    }

    const handleBackClick = () => {
        setCurrentPage(1)
    }
    const exportToExcel = () => {
        const workbook = XLSX.utils.book_new();
        const sheetData = [];
      
        // Prepare the header row
        const headerRow = ['Name', 'Email', 'Studies'];
        sheetData.push(headerRow);
      
        // Prepare the data rows
        const dataRows = filteredData || piList;
        dataRows.forEach((item) => {
          const rowData = [
            item.name,
            item.email,
            item.qr_studies.map((study) => study.study_name).join(', '),
          ];
          sheetData.push(rowData);
        });
      
        const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
      
        // Convert the workbook to an Excel file
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      
        // Create a Blob from the buffer
        const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      
        // Save the Blob as an Excel file
        saveAs(blob, 'Quality_Reviewer_List.xlsx');
      };
   
    
      const handleAscending = () => {
        setAsC(true);
        setDesc(false);  
        const sortedData = [...filteredData];
        sortedData.sort((a, b) => {
          const nameA = a.name || ''; 
          const nameB = b.name || ''; 
          return nameA.localeCompare(nameB);
        });
      
        
        setFilteredData(sortedData);
      };
      
      const handleDescending = () => {
        setDesc(true);
        setAsC(false);
      
        const sortedData = [...filteredData];
        sortedData.sort((a, b) => {
          const nameA = a.name || ''; 
          const nameB = b.name || '';
      
          return nameB.localeCompare(nameA);
        });
       
      
        setFilteredData(sortedData);
      };

const [studyOption, setStudyOption] = useState()

  const handleOptionChange=(e, key, value)=>{
    setStudyOption( value)
   }

   const calculateHeight = (numRecords) => {
    const minHeight = 35; // Minimum height for the td element
    const additionalHeightPerRecord = 20; // Additional height for each record
    const calculatedHeight = minHeight + numRecords * additionalHeightPerRecord;
    return calculatedHeight + "px";
  };
    return (
        <div>
            <NavigationBar studyDropdwn={true} title={'Quality Reviewer'} rolecode={getRoleCode} handleOptionChange={handleOptionChange}/>
            <div className='main_body '>
                {currentPage===1 && <Container fluid className='py-4 '>
                    <Stack direction="horizontal" gap={3} className=" pb-2 add_subject_stack">
                        <div>
                            {studyList &&
                            <select  onChange={handleOptionSelectStudy} className='custom-select' style={{ width: "auto" }} >
                                <option  value={"All Studies"}>All Studies </option >
                                {qrListStudies?.map((option) => (
                                <option key={option.value} value={option.value} title={option.label} >
                                    <div className={`label-style ${window.innerWidth < 768 ? 'mobile' : 'desktop'}`}>
                                        {window.innerWidth < 768
                                            ? option?.label?.length > 30 ? `${option.label.slice(0, 30)}...` : option.label
                                            : option?.label?.length > 40 ? `${option.label.slice(0, 40)}...` : option.label}
                                    </div>
                                </option>
                                ))}
                            </select>
                            }
                            
                        </div>
                        <div>
                            <button className="orange_btn" onClick={handleClearFilters}>Clear</button>
                        </div>

                        <div xs={3} className="ms-auto">
                            <button className="orange_btn" onClick={() =>navigate('/pmsadminaddqr')}>Add Quality Reviewer</button>
                        </div>
                    </Stack>
                    <Container fluid className='pitable_container'>
                        <Row className='searchbar'>
                            <Col className='searchFiled gap-3'>
                                <label htmlFor="" />
                                <input type="text" value={searchText} onChange={handleSearchData} placeholder='Search with Name' />
                                <div className=" ">
                                        <button
                                            className="btn btn-success"
                                            onClick={exportToExcel}
                                            style={{height:"42px"}}
                                        >
                                            Download XLS
                                            <img src="./images/icons/download.svg" alt="#" style={{marginLeft:"5px"}}/>
                                        </button>
                                    </div>
                            </Col>
                        </Row>
 <div>
      {loading_flag ? (
        // <Loader />
        <div className=''>
        <img
          className="atrium_loader"
          src="/images/circle-effect-loading.gif"
          alt="Loader"

        />
      </div>
      ) : (
       
                        <div className='' style={{border:"1px solid #E1E5E7 "}}>
                        <Table bordered size="sm" className='pitable mb-0' >
                            <thead  className='sticky_table_header'>
                                <tr>
                                    <th>S.No </th>
                                    <th className='sticky-header'>
                                    <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                                                        <span style={{ fontSize: 14, fontWeight: 600, marginTop: 0,paddingLeft:"35%" }}>Name</span>
                                                        <svg width="30" height="30" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" style={{float:"right"}}>
                                                                <g id="icon_sort">
                                                                    <path id="icon" d="M13.3471 21.1433C13.1481 21.4277 12.7269 21.4277 12.5279 21.1433L8.23821 15.0152C8.00624 14.6839 8.24332 14.2285 8.64783 14.2285H17.2272C17.6317 14.2285 17.8688 14.6839 17.6368 15.0152L13.3471 21.1433Z" fill={desc?"black":"#E1E5E7"} onClick={handleDescending} className='svg-cursor'/>
                                                                    <path id="icon_2" d="M13.3471 4.31368C13.1481 4.02932 12.7269 4.02932 12.5279 4.31368L8.23821 10.4418C8.00624 10.7732 8.24332 11.2285 8.64783 11.2285H17.2272C17.6317 11.2285 17.8688 10.7732 17.6368 10.4418L13.3471 4.31368Z" fill={asc?"black":"#E1E5E7"} onClick={handleAscending} className='svg-cursor'/>
                                                                </g>
                                                            </svg>
                                                            </div>
                                                            </th>
                                    <th>Email
                                    </th>
                                    <th>Studies
                                    </th>
                                    <th>Action
                                    </th>
                                </tr>
                            </thead>
                            {filteredData === null ? 
                                <tbody>
                                {piList?.map((i, index)=>{
                                    
                                    return(
                                    <tr key={i.mh_id} className='text_left_table'>
                                    <td className='text_right_sno'>{index +1}</td>
                                    <td>{i.name? convertToTitleCase(i.name) : "-"}</td>
                                    <td className='emaill'>{i.email ? i.email : "-"}</td>

                                    <td style={{display:"flex", flexDirection:"column", height: "45px", overflowY: "scroll", textAlign:"center", padding: (i.qr_studies?.length === 1) ? "12px" : "0px"}}>{i.qr_studies ? i.qr_studies.map((j, index) => {
                                         const truncatedStudyName = j.study_name.length > 30 ? j.study_name.substring(0, 30) + "..." : j.study_name;
                                        return(
                                            // <span style={{fontWeight:"600"}}>{j.study_name}{index !== (i.qr_studies?.length - 1) ? ", " : ""}</span>
                                            <span style={{ fontWeight: "600" }}  data-tooltip-id={j.study_name} data-tooltip-content={j.study_name}>
                                            {truncatedStudyName}
                                            {index !== i.qr_studies?.length - 1 ? ", " : ""}
                                            <Tooltip className='tooltip_study' id={j.study_name} style={{ zIndex: 20 }}/>
                                            </span>
                                            
                                        )
                                    }):"-"}</td>
                                    <td className='viewbtnstyl'>
                                        <div style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                                            <button className="gray_btn px-3" style={{marginRight:"20PX"}} onClick={()=>handleSubjectData(i)}>Add to study</button>
                                            <button className="gray_btn px-3" onClick={()=>handleSubjectDataView(i)}>view</button>
                                        </div> 
                                     </td>
                                </tr>)})}
                                 
                            </tbody>
                            :
                            <>
                            {filteredData.length > 0?(
                            <tbody>
                                {filteredData?.map((i, index)=>{
                                    
                                    return(
                                        <tr key={i.mh_id} className='text_left_table'>
                                        <td className='text_right_sno'>{index +1}</td>
                                        <td>{i.name?  i.name :"-"}</td>
                                        <td className='emaill'>{i.email ? i.email :"-"}</td>
                                        <td style={{width:"350px"}}>
                                        <div style={{display:"flex", flexDirection:"column", height: calculateHeight(i.qr_studies.length)-"20px", textAlign:"center", padding: (i.qr_studies?.length === 1) ? "0px" : "0px"}}>{i.qr_studies ? i.qr_studies.map((j, index) => {
                                            //  const truncatedStudyName = j.study_name.length > 30 ? j.study_name.substring(0, 30) + "..." : j.study_name;
                                            return(
                                                <span className='text_left_table' style={{ fontWeight: "600" }} data-tooltip-id={j.study_name} data-tooltip-content={j.study_name}>
                                                    
                                                {j.study_name}
                                                {index !== i.qr_studies?.length - 1 ? ", " : ""}
                                                <Tooltip className='tooltip_study' id={j.study_name} style={{ zIndex: 20 }}/>
                                                </span>
                                            )
                                        }):"-"}</div>
                                        </td>
                                        <td className='viewbtnstyl'>
                                            <div style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                                                <button className="gray_btn px-3" style={{marginRight:"10PX",width:"130px"}} onClick={()=>handleSubjectData(i)}>Add to study</button>
                                                <button className="gray_btn px-3" onClick={()=>handleSubjectDataView(i)}>View</button>
                                            </div> 
                                         </td>
                                    </tr>)})}
                                 
                            </tbody> )
                            :
                            (
                            
                                <tbody>
                                    <tr className='text-center'>
                                    <td colSpan='5'>No records found</td>
                                    </tr>
                                </tbody>
                                  
                            )
                            }
                          </>
                            }
                          
                        </Table>
                        </div>
      )}
    </div>




                    </Container>
                </Container>}
                {currentPage === 2 && selectedPI && 
                <Container fluid className='py-3 page_two_styl'>
                <Row className='d-flex justify-content-between'>
                    <Col><button className="white_btn white_btn_back" onClick={handleBackClick}>{'< '}Back</button> </Col>
                </Row>
                <Container fluid className='py-3 '>
                    <Row className='viewPage'>
                                <div style={{ margin: "24px 32px" }}>
                                    <p style={{ fontWeight: "bold", color: "black", fontSize:"20px"}}>Name: {selectedPI.name}</p>
                                </div>
                                <div style={{ border: "1px dotted #E1E5E7", marginLeft: "32px", marginRight: "32px", width:"85vw"}}></div>
                                <div style={{ display: "flex", flexDirection: "row", margin: "24px 32px 0px 32px", justifyContent: "start", alignItems:"center"}}>
                                    <p style={{marginRight:"20px"}}>
                                        BBIL ID: {" "}
                                        {selectedPI.bbil_employee_id}
                                        {/* <img style={{ height: "20px", margin: "6px", paddingLeft: "5px" }} src="./images/icons/Phone Telephone by Streamlinehq (1).svg" alt="" /> */}

                                    </p>
                                    <p style={{marginRight:"20px", fontWeight:"bolder"}}>.</p>
                                    <p style={{marginRight:"20px"}} className='emaill'>
                                        {selectedPI.email}
                                        <img style={{ height: "20px", margin: "5px" }} src="./images/icons/Mail Send Envelope by Streamlinehqmainemail.svg" alt="" />
                                    </p>
                            </div>
                            <div style={{ border: "1px dotted #E1E5E7", marginLeft: "32px", marginRight: "32px", marginBottom:"32px", width:"85vw"}}></div>
                            {selectedPI.qr_studies?.map((i) => {
                            return(
                                <div className='piViewStudy' style={{width:"85vw"}}>
                                <h5 style={{marginLeft:"15px"}}>{i.study_name}</h5>
                                <div style={{ display: 'flex', flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                                    <div style={{ margin: "24px" }}>
                                        <p>Product Name       : <span style={{color:"black",marginTop:"4px",marginLeft:"4px"}}> {i.product_name}</span></p>
                                        <p>Estimated Sites    : <span style={{color:"black",marginTop:"4px",marginLeft:"4px"}}>{i.estimated_sites}</span></p>
                                        <p>Estimated Subjects :<span style={{color:"black",marginTop:"4px",marginLeft:"4px"}}>{i.estimated_subjects}</span></p>
                                        <p>Number Of Doses    :<span style={{color:"black",marginTop:"4px",marginLeft:"4px"}}>{i.number_of_doses}</span></p>
                                        <p>Age Group    :<span style={{color:"black",marginTop:"4px",marginLeft:"4px"}}>{i.age_group}</span></p>
                                        <p>Study Initiation Date : <span style={{color:"black",marginTop:"4px",marginLeft:"4px"}}>{i.study_initiation_date}</span></p>
                                   
                                    </div>
                                </div>
                                <div style={{ border: "1px dotted #E1E5E7",  }}></div>
                            </div>
                            )
                        })

                        }
                    </Row>
                    
                </Container>
                    </Container>
                }
            </div>

        </div>
    );
};

export default PMSAdminQRList;



